import { authorize, getRequest } from 'utils/http';
import { AWS_API_URL } from 'global/environment';

const url = `${AWS_API_URL}/user/subscriptions`;

export async function getSubscriptionsAPI() {
  return getRequest(url, await authorize());
}
